module.exports = __webpack_public_path__ + "img/2.cf93cca0.png";